/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Abmelden_QuestionInputs */

const de_abmelden_question = /** @type {(inputs: Abmelden_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden?`)
};

/** @type {(inputs: Abmelden_QuestionInputs) => LocalizedString} */
const en_abmelden_question = () => /** @type {LocalizedString} */ ('abmelden_question')

/**

* @param {Abmelden_QuestionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const abmelden_question = /** @type {((inputs?: Abmelden_QuestionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Abmelden_QuestionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_abmelden_question(inputs)
	return en_abmelden_question(inputs)
});